module.exports = __webpack_public_path__ + "static/flags/GM-eab9332ed31a4a0c3ad8d5f2b9b7b403.gif";